const l = {
  name: "Wrench",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.8 40" style="enable-background:new 0 0 39.8 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M39.4,8L39.4,8l-0.2-0.6h0C39.1,7.2,39.1,7,39,6.9c-0.1-0.3-0.3-0.6-0.4-0.9l-1,1l-0.5,0.5l-4.4,4.4l-3.8-0.8
			l-0.8-3.8l4.5-4.5l1.5-1.5c-0.4-0.2-0.9-0.5-1.4-0.6l-0.6-0.2l0,0C31,0.2,29.9,0,28.8,0c-6.1,0-11,4.9-11,11c0,1.4,0.3,2.8,0.8,4
			L1.3,32.2c-0.9,0.9-1.3,2-1.3,3.2c0,1.2,0.5,2.4,1.3,3.2c0.9,0.9,2,1.3,3.2,1.3s2.3-0.5,3.2-1.3l17.3-17.3
			c1.2,0.4,2.4,0.7,3.7,0.7c6.1,0,11-4.9,11-11C39.8,10,39.7,9,39.4,8z M28.8,20c-1.2,0-2.4-0.2-3.6-0.7L24.6,19L6.3,37.2
			c-1,1-2.6,1-3.6,0C2.3,36.8,2,36.1,2,35.5c0-0.7,0.3-1.3,0.8-1.8L21,15.5l-0.3-0.6c-0.6-1.2-0.9-2.5-0.9-3.8c0-5,4-9,9-9
			c0.6,0,1.1,0,1.6,0.1l-4.5,4.5l1.2,6.2l6.2,1.2l4.4-4.4c0.1,0.4,0.1,0.8,0.1,1.3C37.8,16,33.8,20,28.8,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Wrench
};
